module.exports = __webpack_public_path__ + "static/media/confidence.170bb00a.png";